import {useFormContext} from "react-hook-form";

import {Button} from "@/components/button/Button.tsx";
import {Card} from "@/components/card/Card.tsx";
import {TextAreaField} from "@/components/form/fields/TextAreaField.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {MARKDOWN_GUIDE_URL} from "@/lib/links.ts";
import {IncidentState} from "@/lib/types/statuspages.ts";
import {IncidentStateSelectField} from "@/pages/incidents/components/incident-edit/components/updates/IncidentStateSelect/IncidentStateSelectField.tsx";

interface UpdateFieldEditProps {
  name: string;
  previewMarkdown: (markdown: string, state: IncidentState) => void;
}

export const UpdateFieldEdit = ({name, previewMarkdown}: UpdateFieldEditProps) => {
  const {watch, formState} = useFormContext();
  const isNewUpdate = !watch(`${name}.id`);
  const updateIndex = parseInt(name.split(".")[1]);
  const updatesErrors = formState.errors?.updates as Array<{confirmed?: {message?: string}}> | undefined;
  const confirmedError = updatesErrors?.[updateIndex]?.confirmed?.message;
  return (
    <Card className={"d-flex flex-column gap-3"}>
      <div className={"d-flex flex-column gap-4"}>
        <IncidentStateSelectField name={`${name}.incident_state`} label={"Incident Status"} required />
        <TextAreaField
          name={`${name}.description`}
          rows={3}
          label={"Incident Details"}
          tooltip={
            "Describe the incident, such as the impact (what services are impacted). Include key timing, scope, and what you’re doing next."
          }
          supportLink={MARKDOWN_GUIDE_URL}
          supportLinkText={"Markdown supported"}
        />
      </div>
      <div>
        <Button
          variant="secondary"
          disabled={!watch(`${name}.incident_state`)}
          type="button"
          onClick={() => previewMarkdown(watch(`${name}.description`), watch(`${name}.incident_state`))}
        >
          {isNewUpdate ? "Add" : "Update"}
        </Button>
      </div>
      <FormSubtext error={confirmedError} />
    </Card>
  );
};
